
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/productos/destacados",
      function () {
        return require("private-next-pages/productos/destacados/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/productos/destacados"])
      });
    }
  